module.exports = __webpack_public_path__ + "media/icons/app-icon@3x-494e8805.svg";